import { getUserPreferredLanguage, loadFaqTranslations } from "@flixbus-phx/marketplace-common";
import * as React from "react";
import parseArticles from "../../helpers/parseArticles/parseArticles";
import { Article } from "../../types";

type UseFaqArticlesOptions = {
  skip?: boolean;
};

const useFaqArticles = (options?: UseFaqArticlesOptions) => {
  const { skip = false } = options || {};
  const lang = getUserPreferredLanguage();
  const [articles, setArticles] = React.useState<Array<Article>>([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<Error>();

  React.useEffect(() => {
    if (skip) {
      return;
    }

    const fetchArticles = async () => {
      setLoading(true);
      setError(undefined);
      try {
        const faqTranslations = await loadFaqTranslations(lang);
        const result = parseArticles(faqTranslations);
        setArticles(result);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, [lang, skip]);

  return { articles, loading, error };
};

export default useFaqArticles;
